import { render, staticRenderFns } from "./MaterialCheckbox.vue?vue&type=template&id=72a41e03&scoped=true&"
import script from "./MaterialCheckbox.vue?vue&type=script&lang=js&"
export * from "./MaterialCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCheckbox.vue?vue&type=style&index=0&id=72a41e03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a41e03",
  null
  
)

export default component.exports